import { unstable_batchedUpdates } from 'react-dom'
export const batchedUpdates = unstable_batchedUpdates
